var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5143 16.9743C27.118 16.374 27.118 15.4005 26.5143 14.8001C25.9107 14.1996 24.9322 14.1996 24.3286 14.8001L21.6641 17.4506C20.2555 18.8515 20.2555 21.1229 21.6641 22.5239L24.3286 25.1743C24.932 25.7748 25.9107 25.7748 26.5143 25.1743C27.118 24.5739 27.118 23.6006 26.5143 23.0001L25.0311 21.5247H35.7258C36.5794 21.5247 37.2714 20.8363 37.2714 19.9872C37.2714 19.1381 36.5794 18.4497 35.7258 18.4497H25.0311L26.5143 16.9743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4856 5.15815L22.6682 5.15817C25.7982 5.15817 28.3355 7.68217 28.3355 10.7957C28.3355 11.6448 27.6435 12.3332 26.7899 12.3332C25.9363 12.3332 25.2443 11.6448 25.2443 10.7957C25.2443 9.38043 24.091 8.23317 22.6682 8.23317L16.4856 8.23314V5.15815ZM26.7899 29.7581C27.6435 29.7581 28.3355 30.4465 28.3355 31.2956C28.3355 34.4091 25.7982 36.9331 22.6682 36.9331H16.4856V33.8581H22.6682C24.091 33.8581 25.2443 32.7109 25.2443 31.2956C25.2443 30.4465 25.9363 29.7581 26.7899 29.7581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.19336C0 6.71398 0.787146 5.33248 2.09761 4.51187L9.16346 0.750552C12.2939 -1.20972 16.4869 0.898152 16.4869 4.43206V36.5679C16.4869 40.1019 12.2939 42.2097 9.16346 40.2495L2.09765 36.4816C0.787167 35.661 4.12732e-05 34.2795 4.12732e-05 32.8L0 8.19336Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/Log Out.bf28246111b57127fc4d438f3d88b9cf.svg";
export { ForwardRef as ReactComponent };